import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
    Typography,
    Grid,
    Button,
} from '@material-ui/core';
import theme from '../../../theme';
import Icon from '@mdi/react';
import {
    mdiCheck,
    mdiClose,
    mdiMinus
} from '@mdi/js';
import jMoment from 'moment-jalaali';
import SimpleTable from '../../../components/ui/tables/simpletable';
import { baseHead, reportHead } from '../tableheadinfo'
import ExcelExport from '../../../components/export/excelexport';
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexWrap: 'wrap',
            '& .MuiFormControl-marginNormal': {
                marginTop: 0,
            },
        },
        '.margin-date-0': {
            '&.MuiFormControl-marginNormal': {
                marginTop: 0,
            },
        },
        paper: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: '100%',
            paddingTop: theme.spacing(3),
            paddingBottom: theme.spacing(3),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            border: '1px solid #D8D8D8',
            boxShadow: '0px 1px 12px 4px rgba(0, 0, 0, 0.04)',
            borderRadius: '10px',
            backgroundColor: "#fff",
        },
        headerBox: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: '28px',
            position: 'fixed',
            top: '0',
            right: '0',
            width: '100%',
            padding: '20px 68px 20px 90px',
            backgroundColor: "#fff",
            boxShadow: "0px 1px 12px 4px rgba(0, 0, 0, 0.04)",
            zIndex: 12,
        },
        item: {
            display: 'flex',
            alignSelf: 'center',
            alignItems: 'center',
            fontWeight: 500,
            width: '100%',
        },
    }),
);
const Report = (props: any) => {
    const classes = useStyles();

    const NOT_REGISTERED = props.data.REPORT.filter(item => item.status == "NOT_REGISTERED");
    const REGISTERING_IN_3PL = props.data.REPORT.filter(item => item.status == "REGISTERING_IN_3PL");
    const REGISTERED_IN_3PL = props.data.REPORT.filter(item => item.status == "REGISTERED_IN_3PL");

    const excelData = (data: any) => {
        return data.map((item: any) => {
            return {
                id: item.id,
                customerAddress: item.customerAddress,
                centerName: item.centerName,
                partnerName: item.partnerName,
                deliveryDate:
                    item.deliveryDate &&
                    jMoment(item.deliveryDate, 'YYYY/M/D')
                        .locale('fa')
                        .format('jYY/jMM/jDD'),
                deliveryTime: `${jMoment(item.deliveryStartTime, 'hh:mm:ss').locale('fa').format('HH:mm')}
                -
                ${jMoment(item.deliveryEndTime, 'hh:mm:ss').locale('fa').format('HH:mm')}`,
                errorOfSuggestion: item.errorOfSuggestion
            };
        });
    };
    const returnToUpload = () => {
        props.setState("UPLOAD")
    }
    return (
        <>
            <div className={classes.headerBox}>
                <Typography variant="h6" component="h2">
                    گزارش
                </Typography>
                <div>
                    <Button variant='outlined' color="primary" onClick={returnToUpload}>
                        بازگشت به صفحه اصلی
                    </Button>
                </div>
            </div>
            {/* not-approved Table */}
            {props.data.NOT_APPROVED && <Grid container item xs={12} alignItems="flex-end" style={{ marginTop: "50px" }}>
                <Grid container justifyContent='space-between'>
                    <Grid item>
                        <Grid container alignItems="center">
                            <Icon path={mdiClose} size={1} color={'#fff'} style={{ backgroundColor: "#FF2400", borderRadius: "50px", marginLeft: "15px" }} />
                            <h4 className='text-error'>تایید نشده ({props.data.NOT_APPROVED.length} سفارش)</h4>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <ExcelExport data={excelData(props.data.NOT_APPROVED)} label="دریافت" />
                    </Grid>
                </Grid>
                <div className={classes.item}>
                    <div className={classes.paper}>
                        <SimpleTable head={baseHead} data={props.data.NOT_APPROVED} />
                    </div>
                </div>
            </Grid>}
            {/* not-assigned Table */}
            {props.data.NOT_ASSIGNED && <Grid container item xs={12} alignItems="flex-end" style={{ marginTop: "50px" }}>
                <Grid container justifyContent='space-between'>
                    <Grid item>
                        <Grid container alignItems="center">
                            <Icon path={mdiClose} size={1} color={'#fff'} style={{ backgroundColor: "#FF2400", borderRadius: "50px", marginLeft: "15px" }} />
                            <h4 className='text-error'>اختصاص داده نشده ({props.data.NOT_ASSIGNED.length} سفارش)</h4>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <ExcelExport data={excelData(props.data.NOT_ASSIGNED)} label="دریافت" />
                    </Grid>
                </Grid>
                <div className={classes.item}>
                    <div className={classes.paper}>
                        <SimpleTable head={baseHead} data={props.data.NOT_ASSIGNED} />
                    </div>
                </div>
            </Grid>}
            {/* Failed Table */}
            {NOT_REGISTERED.length > 0 && <Grid container item xs={12} alignItems="flex-end" style={{ marginTop: "50px" }}>
                <Grid container justifyContent='space-between'>
                    <Grid item>
                        <Grid container alignItems="center">
                            <Icon path={mdiClose} size={1} color={'#fff'} style={{ backgroundColor: "#FF2400", borderRadius: "50px", marginLeft: "15px" }} />
                            <h4 className='text-error'>ثبت ناموفق در 3PL</h4>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <ExcelExport data={NOT_REGISTERED} label="دریافت" />
                    </Grid>
                </Grid>
                <div className={classes.item}>
                    <div className={classes.paper}>
                        <SimpleTable head={reportHead} data={NOT_REGISTERED} />
                    </div>
                </div>
            </Grid>}
            {/* Processing Table */}
            {REGISTERING_IN_3PL.length > 0 && <Grid container item xs={12} alignItems="flex-end" style={{ marginTop: "50px" }}>
                <Grid container justifyContent='space-between'>
                    <Grid item>
                        <Grid container alignItems="center">
                            <Icon path={mdiMinus} size={1} color={'#fff'} style={{ backgroundColor: "#F2A128", borderRadius: "50px", marginLeft: "15px" }} />
                            <h4 className='text-warning'>در حال پردازش</h4>
                        </Grid>
                    </Grid>
                </Grid>
                <div className={classes.item}>
                    <div className={classes.paper}>
                        <SimpleTable head={reportHead} data={REGISTERING_IN_3PL} />
                    </div>
                </div>
            </Grid>}
            {/* Success Table */}
            {REGISTERED_IN_3PL.length > 0 && <Grid container item xs={12} alignItems="flex-end" style={{ marginTop: "50px" }}>
                <Grid container justifyContent='space-between'>
                    <Grid item>
                        <Grid container alignItems="center">
                            <Icon path={mdiCheck} size={1} color={'#fff'} style={{ backgroundColor: "#329926", borderRadius: "50px", marginLeft: "15px" }} />
                            <h4 className='text-success'>ثبت موفق در 3pl</h4>
                        </Grid>
                    </Grid>
                </Grid>
                <div className={classes.item}>
                    <div className={classes.paper}>
                        <SimpleTable head={reportHead} data={REGISTERED_IN_3PL} />
                    </div>
                </div>
            </Grid>}
        </>
    )
}

export default Report;